import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Optional,
} from '@angular/core';
import { TaskWorkspaceStore } from './state/task-workspace-store';

const USF_CLIENT_ID = 5;

/**
 * This directive exists to bypass angular's security checks that prevent
 * interpolating values into `<object data="____">`. It only does this for the
 * USF client (which embeds PDFs into the workspace). Once we're no longer
 * working with that client or they are able to change to a workflow that
 * doesn't require embedding PDFs, this directive can be removed.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- see comment above
  selector: '[data]',
  standalone: false,
})
export class DataDirective implements OnChanges, AfterViewInit {
  @Input({ required: true }) data: any;

  constructor(
    private el: ElementRef,
    @Optional() private taskWorkspaceStore: TaskWorkspaceStore,
  ) {}

  ngOnChanges() {
    this.updateData();
  }

  ngAfterViewInit() {
    this.updateData();
  }

  private updateData() {
    if (
      // fix me if you change this code
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
      this.el &&
      // fix me if you change this code
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
      this.taskWorkspaceStore &&
      this.taskWorkspaceStore('project').state().client_id === USF_CLIENT_ID
    ) {
      this.el.nativeElement.data = this.data;
    }
  }
}
